import { useRouterState } from '@tanstack/react-router';

import { useTaskSummary } from '@src/features/tasks';
import Badge from '@src/shared/ui/Badge';
import IconButton from '@src/shared/ui/Button/IconButton';
import Link from '@src/shared/ui/Link';
import { Box } from '@src/shared/ui/layout';
import {
  MailIcon,
  NotificationsIcon,
  SearchIcon,
  TasksIcon,
} from '@src/shared/ui/icons';

const StyleSheet = {
  root: {
    alignSelf: 'start',
    color: 'common.black',
    display: 'flex',
    gap: '5px',
    '& .MuiIconButton-root:hover, & .MuiIconButton-root.Mui-active': {
      backgroundColor: 'grey.600',
      color: 'common.black',
    },
  },
};

export default function TopMenu() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isTasksActive = pathname.startsWith('/tasks');
  const { data: taskSummary } = useTaskSummary();
  const pendingTasksCount = taskSummary?.pending_tasks ?? 0;

  return (
    <Box sx={StyleSheet.root}>
      <IconButton color="inherit" disabled>
        <SearchIcon color="inherit" />
      </IconButton>
      <IconButton color="inherit" disabled>
        <Badge badgeContent={1} color="primary" invisible={true}>
          <NotificationsIcon color="inherit" />
        </Badge>
      </IconButton>
      <IconButton color="inherit" disabled>
        <Badge badgeContent={13} color="primary" invisible={true}>
          <MailIcon color="inherit" />
        </Badge>
      </IconButton>
      <IconButton
        color="inherit"
        component={Link}
        to="/tasks"
        className={isTasksActive ? 'Mui-active' : undefined}
      >
        <Badge
          badgeContent={pendingTasksCount}
          color="primary"
          invisible={pendingTasksCount === 0}
        >
          <TasksIcon color="inherit" />
        </Badge>
      </IconButton>
    </Box>
  );
}
